import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { HoldActionErrorDto, PlaceHoldDto, usePatronSession } from '@app/hooks';
import { makeRequest } from '@app/utils';

interface RenewRequestProps {
  itemId: string;
}

interface RenewDto extends PlaceHoldDto {
  dueDate: string;
  overdue: boolean;
}

export const useRenewMutation = (): UseMutationResult<
  RenewDto,
  HoldActionErrorDto,
  RenewRequestProps
> => {
  const { externalSystemId } = usePatronSession();

  return useMutation(({ itemId }: RenewRequestProps) => {
    const patronPath = `/opac-patron/account/${externalSystemId}`;
    const renewPath = `/item/${itemId}/renew`;

    return makeRequest<RenewDto>({
      url: `${patronPath}${renewPath}`,
      method: 'POST',
    });
  });
};
